export const getBlockSelector = name => `.wp-block-${name.replace('/', '-')}`

export const extractBlockStyle = className => {
  if (!className) {
    return null
  }
  const matches = className.toString().match(/(?:^|\s)is-style-([^\s]+)(?:\s|$)/)
  return matches ? matches[1] : null
}


export const blockAttributes = (attributes, blockDefinition) => {
  const defaults = Object.keys(blockDefinition.attributes).reduce((carry, key) => {
    if (attributes.hasOwnProperty(key) === false) {
      carry = {
        ...carry,
        [key]: blockDefinition.attributes[key].default || null
      }
    }
    return carry;
  }, {});
  const atts = {
    ...defaults,
    ...attributes,
  }

  return atts;
}
